import { Option } from '../models/utils';

export const isOptionDisabled = (option: Option): boolean => {
  return 'isDisabled' in option && !!Reflect.get(option, 'isDisabled');
};

export const sortOptions = (optionA: Option, optionB: Option) => {
  const isOptionADisabled = isOptionDisabled(optionA);
  const isOptionBDisabled = isOptionDisabled(optionB);

  if (isOptionADisabled !== isOptionBDisabled) {
    return isOptionADisabled ? 1 : -1;
  }

  return optionA.label.localeCompare(optionB.label);
};
